import { useState } from 'react'
import api from '../../utils/api'
import useToastContext from '../useToastContext'
import { notificationTypes } from '../../contexts/toastContext'
//addToast(notificationTypes.error, `Error al crear el usuario: ${error.response.data.message}`)
//addToast(notificationTypes.success, 'Usuario creado con exito!')

const useApartmentsApi = () => {
  const addToast = useToastContext()
  const [apartmentsState, setApartmentsState] = useState({
    apartments: [],
    isLoading: false,
    error: null,
  })

  const [createApartmentState, setCreateApartmentState] = useState({
    isLoading: false,
    error: null,
  })

  const [updateApartmentState, setUpdateApartmentState] = useState({
    isLoading: false,
    error: null,
  })

  const [deleteApartmentState, setDeleteApartmentState] = useState({
    isLoading: false,
    error: null,
  })

  const [getApartmentsFromBuildingState, setGetApartmentsFromBuildingState] =
    useState({
      apartments: [],
      isLoading: false,
      error: null,
    })

  async function getApartments() {
    try {
      setApartmentsState((currentApartmentsState) => ({
        ...currentApartmentsState,
        isLoading: true,
        error: null,
      }))
      const response = await api.get('/apartments')
      setApartmentsState((currentApartmentsState) => ({
        ...currentApartmentsState,
        apartments: [...apartmentsState.apartments, ...response.data.data],
        isLoading: false,
        error: null,
      }))
    } catch (error) {
      setApartmentsState({ apartments: [], isLoading: false, error })
    }
  }

  async function createApartment(apartment) {
    try {
      setCreateApartmentState((currentCreateApartmentState) => ({
        ...currentCreateApartmentState,
        isLoading: true,
        error: null,
      }))
      const created = await api.post('/apartments', apartment)
      setCreateApartmentState({
        isLoading: false,
        error: null,
      })
      setGetApartmentsFromBuildingState({
        apartments: [
          ...getApartmentsFromBuildingState.apartments,
          created.data,
        ],
        isLoading: false,
        error: null,
      })
      addToast(notificationTypes.success, 'Apartamento creado con exito!')
    } catch (error) {
      addToast(
        notificationTypes.error,
        `Error al crear el apartamento: ${error.response.data.message}`
      )
      setCreateApartmentState({ isLoading: false, error })
    }
  }

  async function updateApartment(apartment) {
    try {
      setUpdateApartmentState((currentUpdateApartmentState) => ({
        ...currentUpdateApartmentState,
        isLoading: true,
        error: null,
      }))
      await api.put(`/apartments/${apartment.id}`, apartment)
      setUpdateApartmentState({
        isLoading: false,
        error: null,
      })
      setGetApartmentsFromBuildingState({
        apartments: getApartmentsFromBuildingState.apartments.map((elem) => {
          if (elem.id === apartment.id) {
            return Object.assign({}, elem, apartment)
          }
          return elem
        }),
        isLoading: false,
        error: null,
      })
      addToast(notificationTypes.success, 'Apartamento actualizado con exito!')
    } catch (error) {
      addToast(
        notificationTypes.error,
        `Error al actualizar el apartamento: ${error.response.data.message}`
      )
      setUpdateApartmentState({ isLoading: false, error })
    }
  }

  async function deleteApartment(id) {
    try {
      setDeleteApartmentState((currentDeleteApartmentState) => ({
        ...currentDeleteApartmentState,
        isLoading: true,
        error: null,
      }))
      await api.remove(`/apartments/${id}`)
      setDeleteApartmentState({
        isLoading: false,
        error: null,
      })
      setGetApartmentsFromBuildingState({
        apartments: getApartmentsFromBuildingState.apartments.filter(
          (elem) => elem.id !== id
        ),
        isLoading: false,
        error: null,
      })
      addToast(notificationTypes.success, 'Apartamento borrado con exito!')
    } catch (error) {
      addToast(
        notificationTypes.error,
        `Error al borrar el apartamento: ${error.response.data.message}`
      )
      setDeleteApartmentState({ isLoading: false, error })
    }
  }

  async function getApartmentsFromBuilding(buildingId) {
    try {
      setGetApartmentsFromBuildingState(
        (currentGetApartmentsFromBuildingState) => ({
          ...currentGetApartmentsFromBuildingState,
          isLoading: true,
          error: null,
        })
      )
      const response = await api.get(`/buildings/${buildingId}/apartments`)
      setGetApartmentsFromBuildingState({
        apartments: response?.data?.data,
        isLoading: false,
        error: null,
      })
    } catch (error) {
      setGetApartmentsFromBuildingState({
        apartments: null,
        isLoading: false,
        error,
      })
    }
  }

  const state = {
    apartmentsState,
    getApartmentsFromBuildingState,
  }

  const methods = {
    getApartments,
    createApartment,
    updateApartment,
    deleteApartment,
    getApartmentsFromBuilding,
  }

  return [state, methods]
}

export default useApartmentsApi
